import React, { useState, useRef, useEffect } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Button } from 'primereact/button';
import { Dropdown } from 'primereact/dropdown';
import { Calendar } from 'primereact/calendar';
import { addLocale } from 'primereact/api';
import Base64Downloader from 'common-base64-downloader-react';
import apis from '../../api';
import { Dialog } from 'primereact/dialog';
import { Toast } from 'primereact/toast';
import { DataScroller } from 'primereact/datascroller';
import './DataScrollerDemo.css';
import useParamsCertificate from '../../helpers/useParamsCertificate'
import dateFormat from '../../services/DateFormat.service';
import { LabelField } from './Certificate.styles';
import { InputText } from 'primereact/inputtext';

/* =============================================================================
Remuner software (c)
Vibe Consulting.
Componente : Certificate
Description : Generación de reporte.
Date Autor Modification
================================================================================
04/11/2021 Cristian Andres Pizo Mina Creación 
05/4/2022 Cristian Andres Pizo Mina - Comentarios
================================================================================ */

export default function Accounting(props) {

    // declaración de constantes
    const [contenido, setContenido] = useState("")
    const toast = useRef(null);
    const [params] = useParamsCertificate();
    const [isOpen, setIsOpen] = React.useState(false);
    const [loading1, setLoading1] = useState(false);
    const [loading2, setLoading2] = useState(false);
    const [loading3, setLoading3] = useState(false);
    const [certificate, setCertificate] = useState([]);
    const elementWidth = { width: "60% ", justifySelf: "center" }
    const headers = { authorization: localStorage.getItem('token') }
    const [listPdf, setListPdf] = useState([]);
    const [correo, setCorreo] = useState(localStorage.getItem('user') ? localStorage.getItem('user') : "")

    // Idioma del componente Calendar
    addLocale('es', {
        firstDayOfWeek: 1,
        dayNames: ['domingo', 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado'],
        dayNamesShort: ['dom', 'lun', 'mar', 'mié', 'jue', 'vie', 'sáb'],
        dayNamesMin: ['D', 'L', 'M', 'X', 'J', 'V', 'S'],
        monthNames: ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'],
        monthNamesShort: ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sep', 'oct', 'nov', 'dic'],
        today: 'Hoy',
        clear: 'Claro'
    });

    // Nombre de lista de certificados
    useEffect(() => {
        let name = [{ name: 'Certificado Laboral' }]
        setListPdf(name);
    }, []);

    // inizializar select pinEntity
    useEffect(() => {
        const template = async () => {
            let plantilla = []
            params.forEach((p) => {
                if (p.TAG === 'pinEntity' || p.TAG === 'pinClient') {
                    plantilla.push({ NAME: p.OPTIONS[0].NAME, CODE: p.OPTIONS[0].CODE, LABEL: p.TAG, SHEET: p.SHEET_POSITION, REQUIRED: p.REQUIRED })
                }
                else {
                    if ((localStorage.getItem('type') === 'CLIENT' || localStorage.getItem('type') === 'APPROVER') && localStorage.getItem('number_id') && p.TAG === 'p_persona') {
                        plantilla.push({ NAME: p.OPTIONS[0].NAME, CODE: p.OPTIONS[0].CODE, LABEL: p.TAG, SHEET: p.SHEET_POSITION, REQUIRED: p.REQUIRED })
                    }
                    else {
                        plantilla.push({ NAME: "", CODE: "", LABEL: p.TAG, SHEET: p.SHEET_POSITION })
                    }
                }
            })
            setCertificate(plantilla)
        }
        template()
    }, [params]);

    // Función mostrar modal lista de certificados
    const showModal = () => {
        setIsOpen(true);
    };

    // Función ocultar modal lista de certificados
    const hideModal = () => {
        setIsOpen(false);
    };

    // Función para generar reporte
    async function generateCertificate(mail = "", send = "NO") {
        const _entidad = localStorage.getItem('entity')
        const option = "1"

        let report = {
            ENTITY: _entidad,
            OPTION: option,
            SEND_MAIL: send,
            EMAIL: mail,
            REPORTS: []
        }

        let max = 0
        certificate.forEach(n => {
            let size = n.SHEET.length
            if (size > max) {
                max = size
            }
        })
        for (let i = 0; i < max; i++) {
            report.REPORTS.push({ PARAMETERS: [] })
        }

        certificate.forEach(n => {
            n.SHEET.forEach(e => {
                report.REPORTS[e].PARAMETERS.push({ LABEL: n.LABEL, VALUE: n.CODE })
            })
        })
        try {

            await apis.postPDF(report, headers).then(res => {
                let _contenido = res.data
                setContenido(_contenido);
                setLoading1(false)
                setLoading3(false)
                if (send === "NO") {
                    showModal()
                }
                else {
                    toast.current.show({ severity: 'success', summary: 'Éxito', detail: "Correo enviado existosamente" })
                }
            })
        }
        catch (err) {
            setLoading1(false)
            setLoading3(false)
            toast.current.show({ severity: 'warn', summary: 'Aviso', detail: err.response.data.message, sticky: true })
        }
    }

    const sendMailCertificate = async () => {
        setLoading3(true)
        const mail = correo
        generateCertificate(mail, "SI")
    }

    // cuerpo de modal lista de certificados
    const itemTemplate = (data) => {
        let file = contenido.PDF[0].DATA
        return (
            <div className="product-item">
                {/* <img src="https://remunerwallet.s3.us-east-2.amazonaws.com/61/firma/unnamed.png" style={{ width: "50px" }} onError={(e) => e.target.src = 'https://www.primefaces.org/wp-content/uploads/2020/05/placeholder.png'} alt={data.name} /> */}
                <div className="product-detail">
                    <div className="product-name text-lg">{data.name}</div>
                    <div className="product-description">{data.description}</div>
                </div>
                <div className="product-action">
                    {contenido.PDF_OUTPUT === '1' ?
                    <Base64Downloader style={{ border: "0px", background: "transparent" }} base64={"data:application/pdf;base64," + file} downloadName="certificado" onDownloadSuccess={() => { setLoading2(false); hideModal() }}>
                        <Button icon="pi pi-arrow-down" loading={loading2} onClick={() => setLoading2(true)} />
                    </Base64Downloader>
                    :
                        <Button icon="pi pi-arrow-down" onClick={() =>  {window.open(file, "_blank"); hideModal() }} />
                    }
                </div>
            </div>
        );
    }

    // Configuración para parametros variables tipo select
    function handleChange(e, d, index) {
        setCertificate(n => {
            let newNomina = [...n]
            newNomina[index] = { ...e.value, LABEL: d.TAG, SHEET: d.SHEET_POSITION }
            return newNomina
        })
    }

    // Configuración para parametros variables tipo calendar
    async function handleChangeDate(e, d, index) {
        let date = dateFormat(e.value)
        setCertificate(n => {
            let newNomina = [...n]
            newNomina[index] = { CODE: date, LABEL: d.TAG, SHEET: d.SHEET_POSITION }
            return newNomina
        })
    }

    // Configuración para parametros variables tipo Text
    async function handleChangeText(e, d, index) {
        setCertificate(n => {
            let newNomina = [...n]
            newNomina[index] = { CODE: e.target.value, LABEL: d.TAG, SHEET: d.SHEET_POSITION }
            return newNomina
        })
    }

    // Return que entrega la pantalla
    return (
        <div className='mt-8'>
            <Toast ref={toast} />

            <Dialog visible={isOpen}
                position="top" style={{ width: "36rem" }} draggable={false} resizable={false} modal onHide={hideModal}>
                <div className="datascroller-demo">
                    <div className="card">
                        <DataScroller value={listPdf} itemTemplate={itemTemplate} rows={5} inline scrollHeight="500px" header="Descarga el documento" />
                    </div>
                </div>
            </Dialog>
            <div class="card surface-section w-6 m-auto  mt-6">
                <div class="grid">
                    <div class="col-12 ">
                        <div className="font-bold text-4xl mt-3">
                            <span className="text-900 ">Certificados</span>
                        </div>
                    </div>
                    <div class="col-12">
                        <div class="grid mt-3">
                            <div class="col-10 m-auto">
                                <div className="field">
                                    <div className='block'>
                                        <span style={{ fontSize: "0.8rem" }}>Campos obligatorios (*)</span>
                                    </div>

                                    <div>
                                        {params.map((d, index) => {
                                            if (d.TAG !== "pinClient" && d.TAG !== "pinEntity" && certificate.length > 0 && typeof certificate[index] !== "undefined") {
                                                let label = d.LABEL

                                                if (d.REQUIRED == "1") {
                                                    label = label + "*"
                                                }
                                                switch (d.TYPE) {
                                                    case "LIST":
                                                        let options = []
                                                        if (d.REQUIRED === "1") {
                                                            options = [...d.OPTIONS]
                                                        }
                                                        else {
                                                            options = [{ CODE: "NULL", NAME: "NO APLICA" }, ...d.OPTIONS]
                                                        }
                                                        return (<>
                                                            <LabelField htmlFor="label">{label}</LabelField>
                                                            <Dropdown
                                                                key={index}
                                                                style={elementWidth}
                                                                value={certificate[index]["NAME"]}
                                                                options={options}
                                                                disabled={localStorage.getItem("type") === "APPROVER" || localStorage.getItem('type') === 'CLIENT' ? true : false}
                                                                filter filterBy="NAME"
                                                                optionLabel="NAME"
                                                                placeholder={certificate[index]["NAME"] ? certificate[index]["NAME"] : "Seleccione"}
                                                                onChange={(e) => handleChange(e, d, index)}
                                                            />
                                                        </>
                                                        );
                                                    case "DATE":
                                                        return (<>
                                                            <LabelField htmlFor="label">{label}</LabelField>
                                                            <Calendar key={d} style={elementWidth} id="navigators" value={certificate[index]}
                                                                onChange={(e) => handleChangeDate(e, d, index)}
                                                                locale="es" dateFormat="dd-mm-yy" showIcon placeholder="Seleccione"
                                                                yearRange="2010:2030" /></>
                                                        );
                                                    default:
                                                        return (<>
                                                            <LabelField htmlFor="label">{label}</LabelField>
                                                            <InputText
                                                                key={d}
                                                                style={elementWidth}
                                                                id="label2"
                                                                type="text"
                                                                value={certificate[index].NAME}
                                                                onChange={(e) => handleChangeText(e, d, index)}
                                                            /></>
                                                        )
                                                }
                                            }
                                        })} </div>
                                </div>
                            </div>

                            <div class="col-10 m-auto">
                                <hr class="my-3 mx-0 border-top-1 " />
                                <Button label="Generar Documento" loading={loading1} onClick={() => { setLoading1(true); generateCertificate() }} />
                                &nbsp;
                                <Button label='Enviar por correo' loading={loading3} onClick={() => sendMailCertificate()} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}